import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-white border-t border-neutral-200 mt-auto py-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-neutral-500">
          <div>
            © {new Date().getFullYear()} {t('appName')}
          </div>
          <div className="flex items-center space-x-4">
            <Link to="/privacy-policy" className="hover:text-neutral-700">
              {t('privacyPolicy')}
            </Link>
            <Link to="/terms-of-service" className="hover:text-neutral-700">
              {t('termsOfService')}
            </Link>
            <a href="mailto:support@hoteliate.com" className="hover:text-neutral-700">
              {t('contactSupport')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
